/**
 * openPopup controller mixin
 */

/**
 * openPopupCtrlMixinFactory
 * returns onOffCtrlMixin mixin factory
 *
 * @class openPopupCtrlMixinFactory
 * @memberof mwApp/common
 * @see mwApp/common
 *
 * @ngdoc factory
 * @name mwApp/common.factory:openPopupCtrlMixinFactory
 */
/* @ngInject */
export default function openPopupCtrlMixinFactory ($uibModal) {
  /**
   * Mixin with openPopup controller method
   *
   * @mixin onOffCtrlMixin
   * @memberof mwApp/common
   * @see mwApp/common
   * @name mwApp/common.mixin:onOffCtrlMixin
   *
   * @type {Object}
   */
  return {
    openPopup: function (text, props = {}) {
      $uibModal.open({
        templateUrl: 'components/common/views/popup.html',
        controller: 'PopupCtrl as vm',
        animation: false,
        size: 'lg',
        resolve: {
          text: function () { return text },
          props: function () { return props }
        }
      })
    }
  }
}
